import { ConnectType, useWallet, WalletStatus } from '@terra-money/wallet-provider';
import { slide as Menu } from 'react-burger-menu';
import { toTerraAmount } from 'functions/toXAmount';
import { uMap } from 'constants/constants';
import { useBalance, useChainAddress } from 'state/global';
import { Link as ScrollLink } from "react-scroll";
import st_nav from "./Nav.module.css";
import st_wallet from "../WalletProvider/WalletButton.module.css";
import { useState } from 'react';
import WalletButton from 'components/WalletProvider/WalletButton';
import useAddress from 'hooks/useAddress';
import { sliced } from 'functions/sliceAddress';
import { DeviceType, deviceType } from "functions/deviceType";
import { ProviderWindow } from "types/types";

declare var window: ProviderWindow;

const MobileNav = () => {
  const { status } = useWallet();
  const user_address = useAddress();
  const { disconnect, connection, availableConnections } = useWallet();
  const [uusd_balance] = useBalance("uusd");
  const [uluna_balance] = useBalance("uluna");
  const [eth_balance] = useBalance("eth");
  const [bnb_balance] = useBalance("bnb");
  const [eth_address] = useChainAddress("address");
  const [network] = useChainAddress("network");

  const Currency = ({ denom }: { denom: string }) => {
    const presentable = uMap.get(denom);
    const balance =
      denom === "uusd"
        ? uusd_balance
        : denom === "uluna"
        ? uluna_balance
        : network.includes("bnb")
        ? bnb_balance
        : eth_balance;

    return (
      <div className={st_wallet.currency}>
        <img src={`/images/tokens/${presentable}.png`} />
        <h5>
          {toTerraAmount(balance).toFixed(3)} {presentable}
        </h5>
      </div>
    );
  };

  const [isOpen, setOpen] = useState(false);

  const handleCloseMenu = () => {
    setOpen(false);
  };
  const handleStateChange = (state: any) => {
    setOpen(state.isOpen);
  };

  const isSafePalOrMMMobile =
    (deviceType() !== DeviceType.DESKTOP && window.ethereum) ||
    availableConnections.some(
      (connection) => connection.identifier === "SafePal"
    );

  return (
    <Menu right isOpen={isOpen} onStateChange={handleStateChange}>
      <a className="menu-item" style={{ cursor: "pointer" }}>
        <ScrollLink
          onClick={handleCloseMenu}
          to="donate_now"
          duration={500}
          spy={true}
          smooth={true}
        >
          Donate Now
        </ScrollLink>
      </a>
      <a className="menu-item" style={{ cursor: "pointer" }}>
        <ScrollLink
          onClick={handleCloseMenu}
          to="all_charities"
          duration={500}
          spy={true}
          smooth={true}
        >
          Humanitarian Relief Partners
        </ScrollLink>
      </a>
      <div className={st_nav.mob_wallet_container}>
        {status === WalletStatus.WALLET_NOT_CONNECTED && <WalletButton />}
        {(status === WalletStatus.WALLET_CONNECTED || eth_address !== "") && (
          <div className={st_wallet.mob_menu_list}>
            <div className={st_wallet.info}>
              <h1 className={st_wallet.type}>
                Wallet:{" "}
                <span>
                  {connection?.name.replace(" Wallet", "") ??
                    (network.includes("bnb") ? "Binance" : "MetaMask")}
                </span>
              </h1>

              <h1 className={st_wallet.address}>
                {sliced(user_address || eth_address, 7, -7)}
              </h1>
            </div>
            <hr />
            <h3 className={st_wallet.title}>Balance</h3>
            {status === WalletStatus.WALLET_CONNECTED && (
              <Currency denom="uluna" />
            )}
            {status === WalletStatus.WALLET_CONNECTED && (
              <Currency denom="uusd" />
            )}
            <Currency denom={`${network.includes("bnb") ? "bnb" : "eth"}`} />
            <button
              className={st_wallet.disconnect}
              onClick={() =>
                status === WalletStatus.WALLET_CONNECTED
                  ? disconnect()
                  : window.location.reload()
              }
            >
              Disconnect
            </button>
          </div>
        )}
      </div>
    </Menu>
  );
};

export default MobileNav;